module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/neutralart-background-1a54d3865efbcf8ee0c08bd36b0e08c0.jpg";